import { SettingsSection } from '@components'

import { Button, Space, Text } from '@billy/design-system'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FecImport } from '@views/settings/routes/OrganizationFecImport'

export const FecImportSection = () => {
  const { t } = useTranslation()
  const [isFecImportOpen, setIsFecImportOpen] = useState(false)

  const handleImportButtonClick = useCallback(() => {
    setIsFecImportOpen(true)
  }, [])

  const handleFecImportClose = useCallback(() => {
    setIsFecImportOpen(false)
  }, [])

  return (
    <SettingsSection>
      <SettingsSection.Content title={t('settings.organization.accounting.fec_file_import')}>
        <Text colorVariant="secondary">{t('settings.organization.accounting.fec_file_import.subtext')}</Text>
        <Space size="s16" />
        <Button onClick={handleImportButtonClick} variant="filled">
          {t('settings.organization.accounting.fec_file_import.import_button')}
        </Button>
      </SettingsSection.Content>
      {isFecImportOpen && <FecImport onClose={handleFecImportClose} />}
    </SettingsSection>
  )
}
